import { render } from "./OPINION_MEMBER_CONSOLIDATED.vue?vue&type=template&id=765e4c95"
import script from "./OPINION_MEMBER_CONSOLIDATED.vue?vue&type=script&lang=js"
export * from "./OPINION_MEMBER_CONSOLIDATED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__